import React from "react";
import "./Service.css";

const services = [
  {
    image: require("../../images/service_body1.jpg"),
    title: "Personal Loans",
    description: "Flexible personal loans tailored to your needs, whether it's for home renovation, education, or medical expenses.",
    details: [
      "Quick approval and minimal documentation",
      "Attractive interest rates and flexible repayment options",
      "No hidden charges or prepayment penalties",
      "Personalized support throughout your loan journey"
    ]
  },
  {
    image: require("../../images/service_body2.jpg"),
    title: "Business Loans",
    description: "Empowering small and medium businesses with quick and easy business loans to help you grow and succeed.",
    details: [
      "Working capital loans for daily operations",
      "Equipment financing and business expansion loans",
      "Competitive rates and fast disbursal",
      "Custom solutions for SMEs and startups"
    ]
  },
  {
    image: require("../../images/service_body3.jpg"),
    title: "Investment Services",
    description: "Diverse investment options to help you build wealth and achieve your financial goals with expert guidance.",
    details: [
      "Mutual funds, stocks, and bonds portfolio management",
      "Retirement and tax-saving investment plans",
      "Personalized financial planning",
      "Regular portfolio reviews and expert advice"
    ]
  },
  {
    image: require("../../images/service_body4.jpg"),
    title: "Insurance Services",
    description: "Comprehensive insurance solutions to protect you and your family from life's uncertainties.",
    details: [
      "Life, health, and travel insurance options",
      "Tailored coverage for individuals and families",
      "Easy claim process and dedicated support",
      "Affordable premiums and flexible plans"
    ]
  }
];

const Service = () => (
  <div className="service-page">
    <h1 className="service-title">Our Services</h1>
    <div className="service-cards">
      {services.map((service, idx) => (
        <div className="service-card" key={idx}>
          <img src={service.image} alt={service.title} className="service-image" />
          <div className="service-info">
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <ul className="service-details">
              {service.details.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Service; 